import { render, staticRenderFns } from "./AssignmentManager.vue?vue&type=template&id=bda094f6&"
import script from "./AssignmentManager.vue?vue&type=script&lang=js&"
export * from "./AssignmentManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports